import { render } from "./wallet.vue?vue&type=template&id=2703bbde&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=2703bbde&lang=scss&scoped=true"
import "./wallet.vue?vue&type=style&index=1&id=2703bbde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2703bbde"]])

export default __exports__